import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PasswordConfirmDialog } from "@/components/PasswordConfirmDialog";
import { GeofenceDialog } from "@/components/GeofenceDialog";
import { toast } from "sonner";
import { MapPinArea, Plus, PencilSimple, Trash } from "@phosphor-icons/react";

const KIND = { posto: "Posto", cliente: "Cliente", oficina: "Oficina", outro: "Outro" };

export default function Geofences() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [delId, setDelId] = useState(null);
  const load = () => api.get("/geofences").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const remove = async () => { await api.delete(`/geofences/${delId}`); toast.success("Cerca removida"); setDelId(null); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight flex items-center gap-3" style={{ fontFamily: "Manrope" }}>
            <MapPinArea size={32} weight="duotone" className="text-blue-600" /> Cercas
          </h1>
          <p className="text-muted-foreground text-sm mt-1">Aviso no app e no Telegram quando o caminhão chega ou sai de um posto ou cliente</p>
        </div>
        <Button onClick={() => setEditing({})} data-testid="btn-new-geofence" className="bg-blue-600 hover:bg-blue-700 text-white gap-1.5"><Plus size={16} /> Nova cerca</Button>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-lg">Locais monitorados ({items.length})</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          {items.length === 0 && <p className="text-sm text-slate-500">Nenhuma cerca cadastrada. Cadastre os postos e clientes onde o caminhão costuma parar.</p>}
          {items.map((g) => (
            <div key={g.id} data-testid={`geofence-row-${g.id}`} className="flex items-center justify-between gap-3 border rounded-lg p-3">
              <div className="min-w-0">
                <div className="font-semibold text-slate-900 truncate">{g.name}</div>
                <div className="text-xs text-slate-500">{KIND[g.kind] || "Outro"} · raio {Math.round(g.radius_m)} m{g.city ? ` · ${g.city}${g.uf ? "/" + g.uf : ""}` : ""}</div>
              </div>
              <div className="flex shrink-0">
                <Button size="icon" variant="ghost" onClick={() => setEditing(g)} data-testid={`btn-edit-geofence-${g.id}`}><PencilSimple size={16} className="text-blue-600" /></Button>
                <Button size="icon" variant="ghost" onClick={() => setDelId(g.id)} data-testid={`btn-delete-geofence-${g.id}`}><Trash size={16} className="text-red-600" /></Button>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
      <GeofenceDialog item={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />
      <PasswordConfirmDialog open={!!delId} onOpenChange={(v) => !v && setDelId(null)} action="exclusão" variant="destructive"
        description="Esta cerca será removida. Confirme sua senha para continuar." onConfirm={remove} />
    </div>
  );
}
